import { render, staticRenderFns } from "./LogoSvg.vue?vue&type=template&id=bd714b98&"
import script from "./LogoSvg.vue?vue&type=script&lang=ts&"
export * from "./LogoSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports